module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp3_2.849d7d47.png";